import { useQuery } from '@tanstack/react-query';

import { freePassQueries } from '../api/freePassQueries';
import useFreePassEnabled from './useFreePassEnabled';
import getCurrentUserId from '@/utils/user/getCurrentUserId';

const usePromoItemsQuery = (promoId: string | undefined) => {
  const enabled = useFreePassEnabled();
  const userId = getCurrentUserId();

  return useQuery({
    ...freePassQueries.items({ userId, promoId: promoId ?? '' }),
    enabled: enabled && Boolean(userId) && Boolean(promoId),
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
};

export default usePromoItemsQuery;
